import 'whatwg-fetch'
import '@babel/polyfill'
import DefaultDefine from '@/define'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import moment from 'moment-timezone';
import ISO6391 from 'iso-639-1';
import VModal from 'vue-js-modal'
import i18n from './i18n'
import vuescroll from 'vuescroll';
import vSelect from 'vue-select';
import "@/scss/default.scss";
import VCalendar from 'v-calendar';
import InfiniteLoading from 'vue-infinite-loading';
import VTooltip from 'v-tooltip'
import {router} from './routes/index.js';
import 'vue-cal/dist/vuecal.css';
import VueCal from 'vue-cal';
import Vuelidate from 'vuelidate'
import VueFriendlyIframe from 'vue-friendly-iframe';
import * as pako from 'pako';

// Amazon Chime SDK를 위한 pako 전역 설정
if (typeof window !== 'undefined') {
  window.pako = pako;
  console.log('[main.js] pako 전역 설정 완료:', !!window.pako);
}
import Draggable from 'vuedraggable';
import firebase from 'firebase/app';
import * as FirebaseConf from './firebase-config';
import ECharts from 'vue-echarts'
import 'echarts';
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import VueEllipseProgress from 'vue-ellipse-progress';
import axios from 'axios';

import './scss/section.scss';
import './scss/patient.scss';

Vue.prototype.$fb = firebase;
Vue.prototype.$fbConf = FirebaseConf;
Vue.prototype.moment = moment;
Vue.prototype._TIME_ZONE = moment.tz.guess();
Vue.prototype.ISO6391 = ISO6391;

Vue.component('Draggable', Draggable);
Vue.component('v-chart', ECharts);
Vue.component('vue-cal', VueCal);
Vue.component('v-select', vSelect);

Vue.use(vuescroll, {
    ops: {
        bar: {
            onlyShowBarOnScroll: false,
            background: '#a3a3a3',
            opacity: 1,
            size: '8px'
        },
        scrollPanel: {
            scrollingY: false
        }
    },
});
Vue.component('vue-scroll', vuescroll);
Vue.use(VueFriendlyIframe);
Vue.use(Vuelidate);
Vue.use(VTooltip);
Vue.use(InfiniteLoading, {
    props: {
        distance: 10,
        spinner: 'circles'
    }
});
Vue.use(VCalendar);
Vue.use(VModal);
Vue.use(VueEllipseProgress);

Vue.config.productionTip = false;

// Ensure every axios request uses the latest tokens from localStorage.
axios.interceptors.request.use(config => {
    try {
        const token = localStorage.getItem('accessToken') || '';
        const refresh = localStorage.getItem('refreshToken') || '';
        if (!config.headers) config.headers = {};
        config.headers['x-access-token'] = token;
        config.headers['x-refresh-token'] = refresh;
    } catch (e) {
        // ignore
    }
    return config;
}, error => Promise.reject(error));

router.onError((error)=> {
    try {
        if (error.toString().toLowerCase().includes("chunk"))
            window.location.href = window.location.origin;
    } catch (e) {

    }
})

// 전역 디버깅 함수 추가 (개발 환경에서만)
if (process.env.NODE_ENV === 'development') {
  // 디버깅 유틸리티 임시 추가
  const logBrowserInfo = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const touchDevice = navigator.maxTouchPoints !== 0;
    const mobile = /iPhone|iPad|iPod|Android/i;
    const isMobile = mobile.test(userAgent);
    const isIpad = userAgent.match(/ipad/i) !== null;

    const edge = userAgent.includes('edg');
    const safari = (userAgent.includes('safari') && !userAgent.includes('chrome'));
    const firefox = userAgent.includes('firefox');
    const samsungBrowser = userAgent.includes('samsungbrowser');
    const chrome = (userAgent.includes('chrome') && !edge && !samsungBrowser);

    console.log('[브라우저 환경 정보]', {
      userAgent,
      isMobile,
      isIpad,
      touchDevice,
      browsers: {
        chrome,
        edge,
        safari,
        firefox,
        samsungBrowser
      },
      notNewWindow: isMobile || firefox || touchDevice,
      speakerNonCheck: isIpad || isMobile || firefox || safari
    });
  };

  const isPopupBlocked = () => {
    try {
      const popup = window.open('', '', 'width=1,height=1');
      if (!popup || popup.closed || typeof popup.closed === 'undefined') {
        return true;
      }
      popup.close();
      return false;
    } catch (e) {
      return true;
    }
  };

  window.debugVideoCall = {
    checkBrowser: () => logBrowserInfo(),
    checkVideoCallState: () => {
      console.log('[영상통화 상태 정보]', {
        videoCallOpen: store.getters.getVideoCallOpen,
        selectedSchedule: store.getters.getVideoCallSelectedSchedule,
        deviceBrowser: store.getters.getDeviceBrowser
      });
    },
    checkPopupBlocked: () => isPopupBlocked(),
    getDeviceBrowser: () => store.getters.getDeviceBrowser,
    getCurrentVideoCallState: () => ({
      open: store.getters.getVideoCallOpen,
      selectedSchedule: store.getters.getVideoCallSelectedSchedule
    }),
    forceOpenVideoCall: (schedule) => {
      store.dispatch('toggleRemoteModal', {open: true, selectedSchedule: schedule || 'test'});
    },
    forceCloseVideoCall: () => {
      store.dispatch('toggleRemoteModal', {open: false, selectedSchedule: ''});
    },
    resetVideoCallState: () => {
      console.log('[DEBUG] 영상통화 상태 강제 리셋');
      store.dispatch('toggleRemoteModal', {open: false, selectedSchedule: ''});
      console.log('[DEBUG] 리셋 완료:', store.getters.getVideoCallOpen);
    },
    testNewWindow: () => {
      console.log('[DEBUG] 새 창 테스트 시작');
      try {
        const newWindow = window.open('/remote', '_blank', 'width=1200,height=800,left=200,top=100');
        if (!newWindow) {
          console.error('[DEBUG] 새 창 열기 실패 - 팝업 차단됨');
          alert('팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.');
        } else {
          console.log('[DEBUG] 새 창 열기 성공:', newWindow);
        }
      } catch (error) {
        console.error('[DEBUG] 새 창 열기 중 오류:', error);
      }
    },
    simulateVideoCallClick: (schedule) => {
      console.log('[DEBUG] 영상통화 클릭 시뮬레이션 시작');
      const testSchedule = schedule || {
        seqSchedule: 'test-' + Date.now(),
        scheduleExpectStartDatetime: new Date().toISOString(),
        scheduleExpectProgressTime: 'PT30M'
      };
      
      // 상태 리셋 후 시뮬레이션
      store.dispatch('toggleRemoteModal', {open: false, selectedSchedule: ''});
      
      setTimeout(() => {
        // PC 환경 시뮬레이션
        if (!store.getters.getDeviceBrowser.notNewWindow) {
          console.log('[DEBUG] PC 환경 시뮬레이션 - store 상태 먼저 업데이트');
          store.dispatch('toggleRemoteModal', {open: true, selectedSchedule: testSchedule});
          setTimeout(() => {
            console.log('[DEBUG] store 상태 업데이트 후 /remote로 이동');
            window.history.pushState({}, '', '/remote');
            // Vue 라우터 강제 업데이트
            window.dispatchEvent(new PopStateEvent('popstate'));
          }, 100);
        } else {
          console.log('[DEBUG] 모바일 환경 시뮬레이션');
          store.dispatch('toggleRemoteModal', {open: true, selectedSchedule: testSchedule});
        }
      }, 100);
    },
    testChimeSDK: () => {
      console.log('[DEBUG] Amazon Chime SDK 테스트');
      try {
        // 동적 import로 테스트
        import('amazon-chime-sdk-js').then(chimeSDK => {
          console.log('[DEBUG] Chime SDK 동적 import 성공:', chimeSDK);
          console.log('[DEBUG] LogLevel:', chimeSDK.LogLevel);
          console.log('[DEBUG] LogLevel.INFO:', chimeSDK.LogLevel?.INFO);
        }).catch(error => {
          console.error('[DEBUG] Chime SDK 동적 import 실패:', error);
        });
      } catch (error) {
        console.error('[DEBUG] Chime SDK 테스트 오류:', error);
      }
    }
  };
  
  console.log('🔧 디버깅 도구가 준비되었습니다. window.debugVideoCall로 접근하세요.');
  console.log('사용 가능한 함수들:');
  console.log('- debugVideoCall.checkBrowser() : 브라우저 환경 확인');
  console.log('- debugVideoCall.checkVideoCallState() : 영상통화 상태 확인');
  console.log('- debugVideoCall.checkPopupBlocked() : 팝업 차단 여부 확인');
  console.log('- debugVideoCall.getDeviceBrowser() : 디바이스 브라우저 정보');
  console.log('- debugVideoCall.getCurrentVideoCallState() : 현재 영상통화 상태');
  console.log('- debugVideoCall.forceOpenVideoCall(schedule) : 강제로 영상통화 열기');
  console.log('- debugVideoCall.forceCloseVideoCall() : 강제로 영상통화 닫기');
  console.log('- debugVideoCall.resetVideoCallState() : 영상통화 상태 리셋');
  console.log('- debugVideoCall.testNewWindow() : 새 창 열기 테스트');
  console.log('- debugVideoCall.simulateVideoCallClick() : 영상통화 클릭 시뮬레이션');
  console.log('- debugVideoCall.testChimeSDK() : Amazon Chime SDK 테스트');
}

// Amazon Chime SDK getStats 오류 전역 처리
window.addEventListener('unhandledrejection', function(event) {
  if (event.reason && event.reason.message && 
      event.reason.message.includes('getStats') &&
      event.reason.message.includes('MediaStreamTrack')) {
    console.warn('[main.js] Amazon Chime SDK getStats 오류 무시:', event.reason.message);
    event.preventDefault(); // 오류 무시
  }
});

// 전역 에러 핸들러
window.addEventListener('error', function(event) {
  if (event.error && event.error.message && 
      event.error.message.includes('DefaultStatsCollector')) {
    console.warn('[main.js] DefaultStatsCollector 오류 무시:', event.error.message);
    return true; // 오류 처리됨
  }
});

new Vue({
    store,
    i18n,
    router,
    render: h => h(App),
}).$mount('#app');